<template>
  <div id="botomCenter" class="content-box-item">
    <div class="bottom-top">
      <el-image :src="require('@/assets/icons/icon-8.png')" fit="fit"/>
      <span class="top-txt">本月排行榜</span>
    </div>
    <div class="bottom-bottom">
      <dv-scroll-board :config="config" style="width:100%;height:100%" />
    </div>
  </div>
</template>

<script>
  const lvl_1_icon = '<div class=\"lvl-icon-con\"><div class="lvl-icon-1"></div></div>';
  const lvl_2_icon = '<div class=\"lvl-icon-con\"><div class="lvl-icon-2"></div></div>';

  export default {
  data() {
    return {
      config: {
        header: ['排名', '服务数', '好评数', '好评率'],
        data: [
          [lvl_1_icon, '135人', '100人', '98%'],
          [lvl_2_icon, '128人', '120人', '93%'],
          ['3', '135人', '100人', '91%'],
          ['4', '128人', '130人', '90%'],
          ['5', '135人', '100人', '80%'],
        ],
        rowNum: 3, //表格行数
        headerHeight: 45,
        headerBGC: '#FFFFFF',
        oddRowBGC: '#FFFFFF', //奇数行
        evenRowBGC: '#FFFFFF', //偶数行
        index: false,
        align: ['center', 'center', 'center', 'center'],
        columnWidth: [120, 120, 120, 120]
      },
      lvl_1_icon: '@/assets/icons/lvl-icon-1.png',
    }
  },
  //
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        this.config.data = [];

        if (newData.serviceRankingList == null){
          return;
        }

        for (let i = 0;i< newData.serviceRankingList.length;++i){

          let d = newData.serviceRankingList[i];
          let rank = d.ranking;
          if (rank ==1){
            rank = lvl_1_icon;
          } else if (rank ==2){
            rank = lvl_2_icon;
          }
          let serviceNum = d.serviceNum + "人";
          this.config.data.push([rank,serviceNum,'--','--']);
        }

      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#botomCenter {
  width: calc(100% - 30px);
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  .bottom-top{
    width: 90%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    margin-top: 5px;
  }
  .top-txt{
    font-size: 20px;
    line-height: 60px;
    text-align: center;
    margin-left: 20px;
    color: #000000;
  }
  .bottom-bottom{
    width: 96%;
    height: calc(100% - 70px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    margin-top: 5px;
  }
  /deep/ .header-item{
    background: #ecf3fd;
    border-radius: 8px;
    color: #f49b0b;
    font-size: 18px;
    margin-left: 10px;
    margin-right: 10px;
  }
  /deep/ .row-item{
    border-bottom: 1px solid #dbdedf;
  }
  /deep/ .ceil{
    margin-left: 10px;
    margin-right: 10px;
    font-size: 18px;
    background-image:-webkit-linear-gradient(left,#0d6fb8, #63b1ff);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  /deep/ .lvl-icon-con{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  /deep/ .lvl-icon-1{
    width: 26px;
    height: 34px;
    background-image: url("~@/assets/icons/lvl-icon-1.png");
    background-size: cover;
  }
  /deep/ .lvl-icon-2{
    width: 26px;
    height: 34px;
    background-image: url("~@/assets/icons/lvl-icon-2.png");
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/data/bottom/bottomCenter.vue